import type { Locale, QuoteResult } from './types';

export function formatMoney(value: number, result: QuoteResult, locale: Locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: result.currency,
    maximumFractionDigits: 0
  }).format(value);
}

export function formatArea(value: number, locale: Locale): string {
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value)} m²`;
}

export function formatLength(value: number, locale: Locale): string {
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value)} m`;
}
